import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import ProdutoFrame from './ProdutoFrame';

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class LinhaProducaoForm extends Component {
  state = {
    registro: {
      lp_idf: 0,
      lp_descricao: '',
      lp_ordem: '0',

      plp_item: { key: '0' },
    },

    listaProdutos: [],
    carregandoForm: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaProdutos: this.props.registroSelecionado.listaProdutos
      }, () => {
        this.refs.lp_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.lp_descricao) || (this.state.registro.lp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    const reg = {
      lp_idf: this.state.registro.lp_idf,
      lp_descricao: this.state.registro.lp_descricao,
      lp_ordem: this.state.registro.lp_ordem ? this.state.registro.lp_ordem : '1',
      listaProdutos: this.state.listaProdutos,
    }

    this.props.onSalvarClick(reg);
  };



  onNovoDesconto = () => {
    if ((!this.state.plp_item) || (this.state.plp_item.key === '0') || (this.state.plp_item.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }

    this.state.listaProdutos.push({
      plp_linha_producao: this.state.lp_idf,
      plp_item: this.state.plp_item.key,
      prod_codigo: this.state.plp_item.prod_codigo,
      prod_descricao: this.state.plp_item.prod_descricao,
      med_descricao: this.state.plp_item.med_descricao,
    });

    this.setState({
      plp_item: { key: '0' },
      listaProdutos: this.state.listaProdutos
    });
  };

  onExcluirProdutoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.plp_item === reg.plp_item);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirProdutoClick(registro)} icon="delete" />
      </Tooltip>
    );
  };


  onChangeProduto = event => {
    const { registro } = this.state;
    registro['plp_item'] = event.plp_item;
    this.setState(event);
  }




  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { lp_idf, lp_descricao, lp_ordem, plp_item } = this.state.registro;
    const { carregandoForm, listaProdutos } = this.state;

    // console.log('LinhaProducaoForm: ', this.state)

    return (
      <Modal
        title={lp_idf ? "Edição de Linha de Produção" : "Cadastro de Linha de Produção"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row style={{ marginBottom: 20 }} >
            <Col xs={24} sm={18} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="lp_descricao"
                ref="lp_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={lp_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6}>
              <span>Ordenação</span>
              <InputForm
                id="lp_ordem"
                ref="lp_ordem"
                maxLength={30}
                onChange={this.onChange}
                value={lp_ordem}
                validator={value => Boolean(value)}
              />
            </Col>



            <div style={{}}>

              <Col xs={24}>
                <div className="div-subTitulo">
                  <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                    Produtos da Linha de Produção
                  </span>
                </div>

                <Col xs={24} style={{}}>
                  <ProdutoFrame
                    label="Produto"
                    id="plp_item"
                    value={plp_item}
                    width={"100%"}
                    onChange={this.onChangeProduto}
                    descricaoPrimeiroItem="Selecione um Produto"
                  />
                </Col>
                <Col xs={24} style={{ marginTop: -20 }}>
                  <Button
                    htmlType="button"
                    onClick={this.onNovoDesconto}
                    icon="plus"
                    className="botoesModalForm2x"
                  > Adicionar
                  </Button>
                </Col>
              </Col>

              <Col xs={24} style={{ marginTop: 25 }}>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  rowKey={(listaProdutos => listaProdutos.plp_item)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={"10%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição do Produto"
                    width={"60%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="med_descricao"
                    dataIndex="med_descricao"
                    title="UN"
                    width={"10%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={"20%"}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </Col>

            </div>

          </Row>


          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LinhaProducaoForm.js